module.exports = {
  decimalToFraction: value => {
    let returnValue
    let decimalPart
    if (value === 0) {
      returnValue = ''
    } else if (!Number.isInteger(value)) {
      let base = Math.floor(value)
      if (base) {
        decimalPart = value - base
      } else {
        decimalPart = value
        base = ''
      }
      decimalPart = parseFloat(decimalPart).toFixed(2)
      if (decimalPart < 0.06) {
        returnValue = { integerValue: base }
      } else if (decimalPart >= 0.06 && decimalPart <= 0.18) {
        returnValue = { base, numerator: 1, denominator: 8 }
      } else if (decimalPart >= 0.19 && decimalPart <= 0.3) {
        returnValue = { base, numerator: 1, denominator: 4 }
      } else if (decimalPart >= 0.31 && decimalPart <= 0.36) {
        returnValue = { base, numerator: 1, denominator: 3 }
      } else if (decimalPart >= 0.37 && decimalPart <= 0.41) {
        returnValue = { base, numerator: 3, denominator: 8 }
      } else if (decimalPart >= 0.42 && decimalPart <= 0.58) {
        returnValue = { base, numerator: 1, denominator: 2 }
      } else if (decimalPart >= 0.59 && decimalPart <= 0.63) {
        returnValue = { base, numerator: 5, denominator: 8 }
      } else if (decimalPart >= 0.64 && decimalPart <= 0.7) {
        returnValue = { base, numerator: 2, denominator: 3 }
      } else if (decimalPart >= 0.71 && decimalPart <= 0.8) {
        returnValue = { base, numerator: 3, denominator: 4 }
      } else if (decimalPart >= 0.81 && decimalPart <= 0.95) {
        returnValue = { base, numerator: 7, denominator: 8 }
      } else {
        returnValue = { integerValue: base + 1 }
      }
    } else {
      returnValue = { integerValue: value }
    }
    return returnValue
  },
  getFormattedCount: count => {
    if (!count) {
      return ''
    }

    let countVal
    if (count >= 1000000) {
      countVal = `${parseFloat((count / 1000000).toFixed(2))}m`
    } else if (count >= 100000) {
      countVal = `${parseFloat((count / 1000).toFixed(0))}k`
    } else if (count >= 1000) {
      countVal = `${parseFloat((count / 1000).toFixed(1))}k`
    } else {
      countVal = count.toString()
    }
    return countVal
  }
}
